import React from "react"
import { useControls } from "react-zoom-pan-pinch"
import { Button } from "reactstrap"

function Controls() {
  const { zoomIn, zoomOut, resetTransform } = useControls()
  return (
    <div className="p-2 hstack gap-2">
      <Button size="sm" className="btn-soft-secondary" onClick={() => zoomIn()}>
        Zoom In
      </Button>
      <Button
        size="sm"
        className="btn-soft-secondary"
        onClick={() => zoomOut()}
      >
        Zoom Out
      </Button>
      <Button
        size="sm"
        className="btn-soft-secondary"
        onClick={() => resetTransform()}
      >
        Reset
      </Button>
    </div>
  )
}

export default Controls
